export const LOGIN_SUCCESS = "@@AUTH_REDUCER/LOGIN_SUCCESS";
export const GET_ERRORS = "@@AUTH_REDUCER/GET_ERRORS";
export const CLEAR_ERRORS = "@@AUTH_REDUCER/CLEAR_ERRORS";
export const SET_DYNAMIC_ROUTE_KEY = "@@AUTH_REDUCER/SET_DYNAMIC_ROUTE_KEY";
export const USER_LOADED = "@@AUTH_REDUCER/USER_LOAD";
export const SET_BASE_URLS = "@@AUTH_REDUCER/SET_BASE_URLS";
export const SET_TENANT = "@@AUTH_REDUCER/SET_TENANT";
